// ** React Imports
import { Outlet } from "react-router-dom";
import { useSelector } from "react-redux";

// ** Core Layout Import
// !Do not remove the Layout import
import Layout from "@layouts/VerticalLayout";

// ** Menu Items Array
import navigation from "@src/navigation/vertical";
import { AccountFeatures } from "@src/redux/reducers/accountFeatures";
import { RootState } from "@src/redux";

const VerticalLayout = (props: any) => {
  const { hideAlternativeTexts } = useSelector<RootState, AccountFeatures>(
    (state) => state.accountFeatures
  );
  const menuData = hideAlternativeTexts
    ? navigation.filter(
        (item) =>
          item.id !== "ai-content-alt" &&
          (item as { header?: string }).header !== "verticalMenu.aiContent"
      )
    : navigation;
  return (
    <Layout menuData={menuData} {...props}>
      <Outlet />
    </Layout>
  );
};

export default VerticalLayout;
